import { computed, onScopeDispose, toRef, watch } from 'vue';
import {
  createSharedComposable,
  useDocumentVisibility,
  useIntervalFn,
} from '@vueuse/core';
import { useReservationsStore } from '@/stores/reservations.store';
import { useRestaurantStore } from '@/stores/restaurant.store';

const useSharedUpcoming = createSharedComposable(() => {
  const store = useReservationsStore();
  const restaurant = useRestaurantStore();
  const visibility = useDocumentVisibility();
  const canPoll = computed(
    () =>
      visibility.value === 'visible' &&
      restaurant.effectiveTier >= 2 &&
      store.upcomingConsumers > 0 &&
      !store.upcomingAccessDenied &&
      store.upcomingSettings?.enabled !== false
  );
  const reload = () => store.loadUpcoming().catch(() => undefined);
  const timer = useIntervalFn(
    () => {
      void reload();
    },
    60_000,
    { immediate: false }
  );
  watch(
    [canPoll, () => restaurant.selectedBranch?.id],
    ([enabled]) => {
      if (enabled) {
        void reload();
        timer.resume();
      } else timer.pause();
    },
    { immediate: true }
  );
  return {
    list: toRef(store, 'upcoming'),
    settings: toRef(store, 'upcomingSettings'),
    status: toRef(store, 'upcomingStatus'),
    error: toRef(store, 'upcomingError'),
    reload,
  };
});

export function useReservationsUpcoming() {
  const store = useReservationsStore();
  store.acquireUpcoming();
  onScopeDispose(() => store.releaseUpcoming());
  return useSharedUpcoming();
}
